<ng-container>
    <div class="inside-container">
        <div fxLayout="row">
            <div fxFlex="70" fxLayoutAlign="start center">
                <h3
                    class="tab-header"
                    i18n="@@25de34d0d480850672ef41a14cee936bee5682df"
                    t="25de34d0d480850672ef41a14cee936bee5682df"
                    >Software Details</h3
                >
                <a target="_blank" [href]="helpUrl">
                    <tsl-icon size="small" class="header-help-icon">help</tsl-icon>
                </a>
            </div>
        </div>
        <br />

        <!-- search box -->
        <div fxLayoutAlign="start center" fxLayoutGap="10px">
            <tsl-form-field fxFlex="20">
                <tsl-label
                    i18n="@@0fbc0bbce830bd50141fac696299f15bed5563c8"
                    t="0fbc0bbce830bd50141fac696299f15bed5563c8"
                    >Category</tsl-label
                >
                <tsl-select id="filter_category" fullWidth [(ngModel)]="filter.softwareCategoryId">
                    <tsl-option *ngFor="let item of softwareCategories$ | async" [value]="item.id">
                        {{ translate.get(item.category) }}</tsl-option
                    >
                </tsl-select>
            </tsl-form-field>

            <tsl-form-field fxFlex="30">
                <tsl-label i18n="@@Name" t="Name">Name</tsl-label>
                <tsl-select id="filter_type" fullWidth [(ngModel)]="filter.softwareTypeId">
                    <tsl-option *ngFor="let item of softwareTypes$ | async" [value]="item.id">
                        {{ translate.get(item.type) }}</tsl-option
                    >
                </tsl-select>
            </tsl-form-field>

            <button
                tsl-button
                color="blue"
                size="small"
                (click)="onFilter()"
                i18n="@@7e892ba15f2c6c17e83510e273b3e10fc32ea016"
                t="7e892ba15f2c6c17e83510e273b3e10fc32ea016"
                >Search</button
            >
            <button
                tsl-button
                color="black"
                outline
                size="small"
                (click)="onClearFilter()"
                i18n="@@99ee4faa69cd2ea8e3678c1f557c0ff1f05aae46"
                t="99ee4faa69cd2ea8e3678c1f557c0ff1f05aae46"
                >Clear</button
            >
        </div>
        <br />

        <div>
            <div class="right-container">
                <button
                    tsl-button
                    [disabled]="preventativeHold==true"
                    color="black"
                    size="small"
                    outline
                    (click)="onAdd()"
                    i18n="@@77913a0c90eec18ceefcb11127b4852f0da5b3c"
                    t="77913a0c90eec18ceefcb11127b4852f0da5b3c4"
                    >Add Software
                </button>
            </div>
            <table tsl-table tslSort [dataSource]="datasource" (tslSortChange)="onSortChange($event)">
                <ng-container tslColumnDef="softwareCategory">
                    <th
                        tsl-sort-header
                        tsl-header-cell
                        *tslHeaderCellDef
                        i18n="@@a5af6340df79c70f88c0c08d5c23568a9eed0bfa"
                        t="a5af6340df79c70f88c0c08d5c23568a9eed0bfa"
                    >
                        Category
                    </th>
                    <td tsl-cell *tslCellDef="let item"> {{ translate.get(item.softwareCategory) }} </td>
                </ng-container>

                <ng-container tslColumnDef="softwareType">
                    <th tsl-sort-header tsl-header-cell *tslHeaderCellDef i18n="@@Name" t="Name">Name </th>
                    <td tsl-cell *tslCellDef="let item"> {{ translate.get(item.softwareType) }} </td>
                </ng-container>

                <ng-container tslColumnDef="version">
                    <th
                        tsl-sort-header
                        tsl-header-cell
                        *tslHeaderCellDef
                        i18n="@@8fe73a4787b8068b2ba61f54ab7e0f9af2ea1fc9"
                        t="8fe73a4787b8068b2ba61f54ab7e0f9af2ea1fc9"
                    >
                        Version
                    </th>
                    <td tsl-cell *tslCellDef="let item"> {{ item.version }} </td>
                </ng-container>

                <ng-container tslColumnDef="description">
                    <th
                        tsl-sort-header
                        tsl-header-cell
                        *tslHeaderCellDef
                        i18n="@@3137d67bb771eeb9ae636670d73bd706258ad1a7"
                        t="3137d67bb771eeb9ae636670d73bd706258ad1a7"
                    >
                        Description
                    </th>
                    <td tsl-cell *tslCellDef="let item"> {{ item.formats }} </td>
                </ng-container>

                <ng-container tslColumnDef="action">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@Action" t="Action"> Action </th>
                    <td tsl-cell *tslCellDef="let item">
                        <button tsl-icon-button i18n-matTooltip  [disabled]="preventativeHold==true" matTooltip="Edit" (click)="onEdit(item)">
                            <tsl-icon>edit</tsl-icon>
                        </button>
                        <button tsl-icon-button i18n-matTooltip  [disabled]="preventativeHold==true" matTooltip="Delete" (click)="onDelete(item)">
                            <tsl-icon status="error">delete</tsl-icon>
                        </button>
                    </td>
                </ng-container>

                <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
                <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <tsl-pagination
                [pageSizeOptions]="pageSizeOptions"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                showFirstLastButtons
                (pageChange)="onPageChange($event)"
                [total]="softwareResult.totalRecords"
                [itemsPerPageLabel]="translate.get('ItemsPerPage')"
            >
            </tsl-pagination>
        </div>
    </div>
</ng-container>
